import { useTrackMarketing } from '@packages/shared/src/hooks/useTrackCampaign/useTrackCampaign';
import { useRef } from 'react';
import { Link } from '@packages/modules/src/Link/Link';
import { cn } from '@packages/shared/src/utils/cn/cn';
import { useAssignLinkTargetBasedOnBotStatus } from '../../hooks/useAssignLinkTargetBasedOnBotStatus';
import type { LinkByTextType } from './types';
import { Icon } from '../Icon/Icon';
import { SoftHyphenInjector } from '../SoftHyphenInjector';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import { ComponentTypes } from '../../../interfaces';
import { buildLinkWithArguments } from '../../utils/buildLinkWithArguments';

/**
 * LinkByText component displays link with Arguments and an optional Icon with a direction
 * */
export const LinkByText = ({ data, className }: { data: LinkByTextType; className?: string }) => {
  const {
    field_link: link,
    field_link_target: linkTarget,
    behavior_paragraph_link_rel: linkRelRaw,
    field_direction: direction,
    field_text: text,
    field_icon: icon,
  } = data;
  const linkRel = linkRelRaw === '_none' ? undefined : linkRelRaw;
  const tmpLink = buildLinkWithArguments(link, data);
  const assignLinkTarget = useAssignLinkTargetBasedOnBotStatus();
  const finalLink = assignLinkTarget(tmpLink);
  const linkRef = useRef<HTMLAnchorElement>(null);
  const { trackClick } = useTrackMarketing(data, linkRef, finalLink);
  return (
    <Link
      className={cn(
        'text-color-text-dark decoration-color-text-dark inline-flex items-center underline [&_svg]:h-2! [&_svg]:w-auto!',
        direction === 'left' && '[&_svg]:order-[-1]',
        className,
      )}
      ref={linkRef}
      href={finalLink}
      onClick={() => trackClick()}
      openInNewTab={!!(linkTarget && linkTarget === '_blank')}
      rel={linkRel}
    >
      <SoftHyphenInjector text={text} />
      {icon && <Icon type={icon} />}
    </Link>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.LinkByText]: LinkByText });
